import { SliderTrack, type SliderTrackProps } from '@chakra-ui/react';

export type UiSliderTrackProps = SliderTrackProps;

export const UiSliderTrack = SliderTrack;
